import { getPageData } from '../lib/api'
import Head from 'next/head'
 
import { useNotifyModal } from "/lib/hooks/useNotifyModal";
import dynamic from "next/dynamic";
const NotifyModal = dynamic(() => import('/components/NotifyModal'))

function termnConditionPage({ pageContent }) {
    const seo = pageContent?.seo || null
    pageContent = pageContent?.pwa || null

     
    const { showNotifyModal, handleModalClose } = useNotifyModal();

    if (!pageContent) return null;
    return (
        <>
            <Head>
                {(seo.title) ? (<title>{seo.title}</title>) : null}
                {(seo.title) ? (<meta name="title" content={seo.title} />) : null}
                {(seo.metaDesc) ? (<meta name="description" content={seo.metaDesc} />) : null}
                {(seo.metaKeywords) ? (<meta name="keywords" content={seo.metaKeywords} />) : null}
                {(seo.opengraphTitle) ? (<meta property="og:title" content={seo.opengraphTitle} />) : null}
                {(seo.opengraphDescription) ? (<meta property="og:description" content={seo.opengraphDescription} />) : null}
                {(seo.opengraphImage && seo.opengraphImage.sourceUrl) ? (<meta property="og:image" content={seo.opengraphImage.sourceUrl} />) : null}
                {(seo.twitterDescription) ? (<meta property="twitter:description" content={seo.twitterDescription} />) : null}
                {(seo.twitterTitle) ? (<meta property="twitter:title" content={seo.twitterTitle} />) : null}
                <link rel="stylesheet" href="/css/terms-conditions.css" />
            </Head>
            {showNotifyModal ? <NotifyModal
                handleModalClose={handleModalClose}
                className='notifyContent'
                isOpen={showNotifyModal}
            /> : null}
            <div dangerouslySetInnerHTML={{ __html: pageContent.section1 }} />
        </>
    )
}

export async function getStaticProps() {
    try {
        var pageContent = await getPageData("terms-conditions");
        return {
            props: {
                pageContent,
            },
            revalidate: 600,
        }
    } catch (error) {
        return {
            notFound: true,
            revalidate: 600,
        };
    };
}


export default termnConditionPage;